// const apiUrl = ""
const apiUrl =  process.env.NODE_ENV !== 'development' ? "https://m.rastargame.com" : '';
const gamecenterUrl = "https://gamecenter.rastargame.com";
// 正式环境
export default {
  v2: {
    // 游戏列表
    gameList: apiUrl + "/v2/rebate/get-papp-id",
    // 角色列表
    roleList: gamecenterUrl + "/pf-apiv1/comm/role-list",
    // 获取用户入口信息
    getUserInfo: apiUrl + "/v2/rebate/get-user-info",
    // 获取活动规则接口
    getRules: apiUrl + "/v2/rebate/get-activity-rules",
    // 返利活动开团接口
    getOpenGroup: apiUrl + "/v2/rebate/activity-open-group",
    // 获取用户团队信息接口（要登录）
    getUserGroupInfo: apiUrl + "/v2/rebate/get-user-group-info",
    // 获取团队信息接口（不用登录）
    getGroupInfo: apiUrl + "/v2/rebate/get-group-info",
    // 获取礼包列表
    getGiftList: apiUrl + "/v2/rebate/get-gift-list",
    // 队员加入队伍
    joinGroup: apiUrl + "/v2/rebate/join-activity-group",
    // 领取礼包
    getGift: apiUrl + "/v2/rebate/get-gift-reward",
    //返利活动获取微信用户信息
    getWxUser: apiUrl + "/v2/rebate/get-wx-user",
    // 查看充值数据
    payData: apiUrl + "/v2/rebate/get-recharge-data",
    // 换绑游戏、角色接口
    updateInfo: apiUrl + "/v2/rebate/change-role",
    // 获取首页高额奖励列表接口
    homeRewardList: apiUrl + "/v2/rebate/get-homepage-reward-list",
    // 领奖日志
    getRewardLog: apiUrl + "/v2/rebate/get-reward-log",
    // 活动状态
    getActivityStatus: apiUrl + "/v2/rebate/get-activity-status",
    // 退出
    logout: "https://pt-u.rastargame.com/cv1/Logout/do_",
  },
  // 游戏列表
  gameList: apiUrl + "/v1/rebate/get-papp-id",
  // 角色列表
  roleList: gamecenterUrl + "/pf-apiv1/comm/role-list",
  // 微信授权
  wxOauth: "https://pt-u.rastargame.com/common/WechatCommon/oauth/",
  // 获取主游戏id
  getPappId: apiUrl + "/v1/rebate/get-papp-id",
  // 获取微信信息接口
  getWechatInfo: apiUrl + "/v1/rebate/get-oauth2-info",
  // 检查返利活动状态接口
  getActivityStatus: apiUrl + "/v1/rebate/get-activity-status",
  // 获取团队信息接口（不用登录）
  getGroupInfo: apiUrl + "/v1/rebate/get-group-info",
  // 获取用户团队信息接口（要登录）
  getUserGroupInfo: apiUrl + "/v1/rebate/get-user-group-info",
  // 判断用户是否有团队接口
  getValidatIsGroup: apiUrl + "/v1/rebate/validate-is-group",
  // 检查用户开团组队状态接口
  getGroupStatus: apiUrl + "/v1/rebate/check-open-group-status",
  // 返利活动开团接口
  getOpenGroup: apiUrl + "/v1/rebate/activity-open-group",
  // 队员加入队伍
  joinGroup: apiUrl + "/v1/rebate/join-activity-group",
  // 查看充值数据
  payData: apiUrl + "/v1/rebate/check-recharge-data",
  // 获取可领取礼包列表接口
  getGift: apiUrl + "/v1/rebate/get-gift-card",
  // 获取活动规则接口
  getRules: apiUrl + "/v1/rebate/get-activity-rules",
  // 检查领取礼包状态
  getReward: apiUrl + "/v1/rebate/get-reward-status",
  // 领取礼包接口接口
  giftReward: apiUrl + "/v1/rebate/get-gift-reward",
  // 获取微信分享数据
  getWechat: "/share",
  // 获取活动图片
  getImage: apiUrl + "/v1/rebate/get-activity-image",
};
